import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import './index.css'

// Single global React Query client. Feature hooks (e.g. the Treasury Curve
// dashboard) rely on this provider for caching, background refetch and the
// shared isLoading/error contract. Defaults are conservative for a gated
// financial dashboard: don't refetch on window focus, retry once on
// transient network errors.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

// BrowserRouter is mounted here (rather than in App) so any future test
// utilities that render <App /> can wrap it in a MemoryRouter without
// fighting an already-mounted history.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)